// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetUriRequest, TGetUriModel, IMappers, TGetUriResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetUriV1Response } from '../../entities/get_uri/GetUriV1Response';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetUriModel(parameters: IGetUriRequest): TGetUriModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'seo-urls',
    pathApi: '/v1/get-uri/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetUriOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetUriRequest;
}

export async function fetchGetUri<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetUriOptions<TResponse200, TResponse400>): Promise<FetchResponse<TGetUriResponse> | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetUriModel(parameters),
    config,
  )) as FetchResponse<TGetUriResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetUriV1Response, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetUriResponse>;
}
